import AltTitle from "../components/ui/AltTitle";
import StrokeTitle from "../components/ui/StrokeTitle";
import { useInView } from 'react-intersection-observer';
import { useState, useEffect } from "react";
import FlowerTitle from "../components/ui/FlowerTitle";

const Pirilika = () => {
  return (
    <div className="page-container">
      <div className="article-wrapper"
        style={{
          display: "flex",
          flexDirection: 'column',
          alignItems: 'center',
          width: '100%',
          minHeight: '100vh'
        }}
      >
        <FlowerTitle text="Pirilika's Guide"/>
        <ArticleImage image="header"/>
        <AltTitle text="Pirilika's Guide to Hinomoto Hot Spots"/>
        <div className="text-wrapper" style={{margin: 'none !important'}}>
          <p className="white-text" style={{textAlign: 'left', padding: '25px 0px'}}>
              Hey there, fellow Hinomoto otakus! Pirilika here, coming at you with a travel guide for all the best spots in Hinomoto! <br/> <br/>

              Hinomoto tourism has been booming with Netherworld travelers lately, and who can blame them? Hinomoto's the best! But tons of demons have come up to me and asked "Miss Pirilika, how do you manage to dress so impeccably every day? Also, where should I go in Hinomoto?" So I tell them about how I base all of my out<span style={{letterSpacing: '1px'}}>fi</span>ts on Hinomoto styles, like the traditional Hinomoto 'sailor few-ku' that I'm wearing right now. <br/> <br/>

              As for where to go in Hinomoto, I knew I just had to make a travel guide to help all the poor, lost souls who found themselves stuck like strangers in a fanged band! Without further to-do, these are my top picks for Hinomoto's hottest spots!
          </p>
        </div>
      </div>
      <ArticleSmallImage image='ewwdo'/> 
      <StrokeTitle text="Ewwdo" style={{margin: '0px'}}/>
      <div className="text-wrapper" style={{margin: 'none !important'}}>
        <p className="white-text" style={{textAlign: 'left', padding: '25px 0px'}}>
            Our <span style={{letterSpacing: '1px'}}>fi</span>rst stop is the home of the Hinomoto shogunate, Ewwdo Castle! This place is sooo Hinomoto! Abso-posi-lutely iconic! (When it's not being blown up, at least...)  <br/> <br/>

            Just look at that classic, Hinomoto architecture! It looks just like it did in the My Demon Samurai movie! And those signature blue tiled roofs!  <br/> <br/>

            Can't you just picture a traditional Hinomoto ninja going "nin nin nin" across those rooftops? Hinomoto-rri<span style={{letterSpacing: '1px'}}>fi</span>c! <br/> <br/>

            If I have one warning to give you, it's this: do not go to the noodle stall near the castle, it's a total scam. (They don't even serve sowba or you-don! What a rip-off!)

        </p>
      </div>
      <ArticleSmallImage image='yokohorror'/>      
      <StrokeTitle text="Yokohorror"/>
      <div className="text-wrapper" style={{margin: 'none !important'}}>
        <p className="white-text" style={{textAlign: 'left', padding: '25px 0px'}}>
            UGH! Who put this place on the list?! It smells like rusty metal, and the buildings are just...boring! This is so not-Hinomoto, it wounds my otaku soul! <br/> <br/>

            I've always wanted to see everything Hinomoto has to offer, but you know what they say: be careful what you squish for...
        </p>
      </div>
      <ArticleSmallImage image='sardemon'/> 
      <StrokeTitle text="Sardine World"/>
      <div className="text-wrapper" style={{margin: 'none !important'}}>
        <p className="white-text" style={{textAlign: 'left', padding: '25px 0px'}}>
            Now this is more like it! Fish is a super important part of the Hinomoto diet, as shown in their most traditional food: sushy! And if you want sushy with sardines (or as they call it in Hinomoto, "ee-washy"), then you've gotta check out Sardine World! <br/> <br/>

            This Netherworld has everything: it's full of sardines, it smells like sardines, and it's even inside of a giant sardine! I never did get to have any ee-washy sushy in Sardine World, but you can bet your buttoned collar it'll be the <span style={{letterSpacing: '1px'}}>fi</span>rst thing I'm trying next time I visit!

        </p>
      </div>
      <ArticleSmallImage image='gero'/> 
      <StrokeTitle text="Gero Haunt Springs"/>
      <div className="text-wrapper" style={{margin: 'none !important'}}>
        <p className="white-text" style={{textAlign: 'left', padding: '25px 0px'}}>
            Ahh, this is truly the very essence of Hinomoto: a haunt springs resort! This de<span style={{letterSpacing: '1px'}}>fi</span>nitely gets the of<span style={{letterSpacing: '1px'}}>fi</span>cial Pirilika Seal of Approval as a top-tier vacation destination. I could gush for hours about the Hinomoto vibe you get from this place, but you should really see it for yourself. Like they say: a picture's worth one thousand birds!<br/> <br/>

            Once you arrive, I recommend getting into the haunt springs right away. If someone challenges you to a friendly game of ping-pong, avoid them at all costs! They're just trying to keep you from the haunt springs! (And make sure your package deal includes access to the baths!)<br/> <br/>

            And of course, after a nice dip, you've just gotta have some nice, cold fruit milk. Plus, I hear the dark dumplings are really to die for! <br/> <br/>


            There you have it, my Hinomoto travel guide! I hope these tips help make your next trip to Hinomoto totally bushido-tastic! You know, I'm really good at this, maybe I should start giving tours? Wait, if I give tours instead of writing travel guides, I could charge money for them...! FORGET EVERYTHING YOU READ HERE! Pirilika's Hinomoto Tours are coming soon to a Netherworld near you!

        </p>
      </div>
    </div>
  )
}

const ArticleImage = ({image}) => {

  const [ref, inView, entry] = useInView({
    threshold: 1,
    triggerOnce: true
  });

  return(
    <img className={`ss-system ${inView && 'opacity-100'}`} src={`${process.env.PUBLIC_URL}/img/pirilika/${image}.webp`} 
      ref={ref}
      alt="Top-SS" 
      style={{
          maxWidth: '600px',
          width: '95vw',
          marginTop: '50px',
          opacity: '0',
          transition: '0.5s',
          transitionDelay: '0.5s',
          transform: 'translateY(25px)'
    }}/>
  )
}


const ArticleSmallImage = ({image}) => {

  const [ref, inView, entry] = useInView({
    trackVisibility: true,
    threshold: 1,
    triggerOnce: true,
    delay: 100
  });

  const [imageLoaded, setLoaded] = useState(false);
  
  
  useEffect(() => {
    const img = new Image();
    img.onload = () => {
      setLoaded(true);
    };
    img.src = `${process.env.PUBLIC_URL}/img/pirilika/${image}.webp`;
  }, []);

  return(
    <img className={`ss-system ${inView && imageLoaded && 'opacity-100'}`} src={`${process.env.PUBLIC_URL}/img/pirilika/${image}.webp`} 
      ref={ref}
      alt="Top-SS" 
      style={{
          maxWidth: '600px',
          width: '95vw',
          marginTop: '50px',
          opacity: '0',
          transition: '0.5s',
          transitionDelay: '0.5s',
          transform: 'translateY(25px)'
    }}/>
  )
}

export default Pirilika;